import React, { useEffect, useRef, useState } from "react";
import { RiCloseLine } from "react-icons/ri";
import countries from "./countries.json";
import cities from "./cities.json";
const AddPointOfSale = ({ open, setOpen, setFormData, formData, mutation }) => {
  console.log(formData);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [countrySearch, setCountrySearch] = useState("");
  const [stateSearch, setStateSearch] = useState("");
  const [showCountryDropdown, setShowCountryDropdown] = useState(false);
  const [showStateDropdown, setShowStateDropdown] = useState(false);

  const countryRef = useRef(null);
  const stateRef = useRef(null);
  const [errors, setErrors] = useState();
  // Filter countries based on search
  const filteredCountries = countries.filter((country) =>
    country.name_fr.toLowerCase().includes(countrySearch.toLowerCase())
  );

  // Get states based on selected country
  // const countryStates = cities.filter(
  //   (city) => city.stateId === String(selectedCountry)
  // );

  // Filter states based on search
  // const filteredStates = countryStates.filter((state) =>
  //   state.name_fr.toLowerCase().includes(stateSearch.toLowerCase())
  // );

  // Handle country selection
  const handleSelectCountry = (country) => {
    setSelectedCountry(country.id);
    setCountrySearch(country.name_fr);
    setFormData({ ...formData, pays: country.name_fr });
    setShowCountryDropdown(false);
    setSelectedState("");
    setStateSearch("");
  };
  function convertUnicodeToEmoji(unicode) {
    return unicode
      .split(" ")
      .map((u) => String.fromCodePoint(parseInt(u.replace("U+", ""), 16)))
      .join("");
  }
  // Handle state selection
  const handleSelectState = (state) => {
    setSelectedState(state.id);
    setStateSearch(state.name_fr);
    setFormData({ ...formData, address: state.name_fr });
    setShowStateDropdown(false);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (countryRef.current && !countryRef.current.contains(event.target)) {
        setShowCountryDropdown(false);
      }
      if (stateRef.current && !stateRef.current.contains(event.target)) {
        setShowStateDropdown(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  if (!open) return null;
  // Handle changes in input fields
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: name === 'type' ? Number(value) : value,
    });
    // Also update address when city changes
    if (name === 'city') {
      setFormData(prev => ({ ...prev, address: value }));
    }
    setErrors({ ...errors, [name]: "" }); // Clear error when user starts typing
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();

    const dataToSend = {
      ...formData,
      ville: formData.ville || "", // Add ville field
      // Ensure type is a number
      type: Number(formData.type) || 0, // Default to 0 (Web) if not set
    };
    // Pass the data to mutation function
    mutation.mutate({ data: dataToSend });
  };

  return (
    <div
      className="fixed inset-0 z-50"
      style={{ zIndex: 9999, overflow: "visible" }}
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      {/* Overlay */}
      <div
        className="fixed inset-0 bg-gray-500 bg-opacity-75"
        aria-hidden="true"
        onClick={() => setOpen(false)} // Close modal when clicking the overlay
      />

      {/* Modal Content */}
      <div className="flex items-center justify-center min-h-screen p-4">
        <div
          className="relative w-full max-w-lg mx-auto bg-white shadow-lg rounded-lg overflow-hidden"
          onClick={(e) => e.stopPropagation()} // Prevent clicks inside the modal from closing it
        >
          {/* Header */}
          <div className="flex justify-between items-center p-6 bg-[#b269ae] border-b border-gray-500/30 pb-4">
            <h3
              id="modal-title"
              className="text-lg font-medium leading-6 text-white"
            >
              Ajouter un point de vente
            </h3>
            <button
              type="button"
              className="inline-flex items-center justify-center p-1.5 text-gray-400 hover:text-gray-500 hover:scale-105 duration-200"
              onClick={() => setOpen(false)}
            >
              <RiCloseLine className="h-6 w-6 text-white" aria-hidden="true" />
            </button>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4 p-6">
            <div className="grid grid-cols-1 gap-x-4 sm:grid-cols-2 gap-y-4 mt-8">
              <div>
                <label
                  htmlFor="name"
                  className="block text-sm font-medium text-gray-700"
                >
                  Nom du magasin
                </label>
                <input
                  id="name"
                  name="name"
                  type="text"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm focus:border-[--secondaryColor] focus:ring-[--secondaryColor] sm:text-sm h-12"
                />
              </div>
              <div>
                {/* Country Input */}
                <label
                  htmlFor="pays"
                  className="block text-sm font-medium text-gray-700"
                >
                  Pays
                </label>
                <div className="relative" ref={countryRef}>
                  <input
                    type="text"
                    id="pays"
                    value={countrySearch}
                    onChange={(e) => {
                      setCountrySearch(e.target.value);
                    }}
                    onClick={() => setShowCountryDropdown(true)} // Open dropdown on click
                    placeholder="Rechercher un pays..."
                    className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm py-2 px-3 h-12"
                  />
                  {showCountryDropdown && (
                    <ul className="absolute z-10 mt-1 w-full bg-white border border-gray-300 rounded-md shadow-lg max-h-48 overflow-y-auto">
                      {filteredCountries.map((country) => (
                        <li
                          key={country.id}
                          onClick={() => handleSelectCountry(country)}
                          className="px-3 py-2 cursor-pointer hover:bg-gray-200"
                        >
                          {convertUnicodeToEmoji(country.emojiU)}{" "}
                          {country.name_fr}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>

              <div>
                <label
                  htmlFor="ville"
                  className="block text-sm font-medium text-gray-700"
                >
                  Ville (Texte)
                </label>
                <input
                  id="ville"
                  name="ville"
                  type="text"
                  value={formData.ville}
                  onChange={handleChange}
                  placeholder="Ville (texte)"
                  className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm py-2 px-3 h-12"
                />
              </div>
              <div>
                <label
                  htmlFor="address"
                  className="block text-sm font-medium text-gray-700"
                >
                  Adresse
                </label>
                <input
                  id="address"
                  name="address"
                  type="text"
                  value={formData.address}
                  onChange={handleChange}
                  placeholder="Adresse"
                  className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm py-2 px-3 h-12"
                />
              </div>
              <div>
                <label
                  htmlFor="code_postal"
                  className="block text-sm font-medium text-gray-700"
                >
                  Code Postal
                </label>
                <input
                  id="code_postal"
                  name="code_postal"
                  type="text"
                  value={formData.code_postal}
                  onChange={handleChange}
                  required
                  className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm focus:border-[--secondaryColor] focus:ring-[--secondaryColor] sm:text-sm h-12"
                />
              </div>
              <div>
                <label
                  htmlFor="contact_number"
                  className="block text-sm font-medium text-gray-700"
                >
                  Numéro de contact
                </label>
                <input
                  id="contact_number"
                  name="contact_number"
                  type="text"
                  value={formData.contact_number}
                  onChange={handleChange}
                  required
                  className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm focus:border-[--secondaryColor] focus:ring-[--secondaryColor] sm:text-sm h-12"
                />
              </div>
              <div>
                <label
                  htmlFor="responsable_name"
                  className="block text-sm font-medium text-gray-700"
                >
                  Nom du Responsable
                </label>
                <input
                  id="responsable_name"
                  name="responsable_name"
                  type="text"
                  value={formData.responsable_name}
                  onChange={handleChange}
                  required
                  className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm focus:border-[--secondaryColor] focus:ring-[--secondaryColor] sm:text-sm h-12"
                />
              </div>
              <div>
                <label
                  htmlFor="mail"
                  className="block text-sm font-medium text-gray-700"
                >
                  Mail
                </label>
                <input
                  id="mail"
                  name="mail"
                  type="text"
                  value={formData.mail}
                  onChange={handleChange}
                  required
                  className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm focus:border-[--secondaryColor] focus:ring-[--secondaryColor] sm:text-sm h-12"
                />
              </div>
              <div>
                <label
                  htmlFor="type"
                  className="block text-sm font-medium text-gray-700"
                >
                  Type
                </label>
                <select
                  id="type"
                  name="type"
                  value={formData.type}
                  onChange={handleChange}
                  className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm focus:border-[--secondaryColor] focus:ring-[--secondaryColor] sm:text-sm h-12"
                >
                  <option value="0">Web</option>
                  <option value="1">Non-Web</option>
                </select>
              </div>
            </div>
            <div className="mt-6 flex justify-end gap-6">
              <button
                type="submit"
                className="block rounded-md bg-[#b269ae] px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-yellow-300 duration-300 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-yellow-600"
              >
                Ajouter
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddPointOfSale;
